import type { Overall } from '../lib/api';
import { CheckCircle2, AlertTriangle, AlertOctagon, Loader2 } from 'lucide-react';

const COPY: Record<Overall, { title: string; sub: string; pill: string; icon: typeof CheckCircle2; tag: string }> = {
  operational: {
    title: 'All systems are flying.',
    sub: 'Every customer-facing route is responding normally.',
    pill: 'pill-green',
    icon: CheckCircle2,
    tag: 'All systems operational',
  },
  degraded: {
    title: 'Partial degradation detected.',
    sub: 'Some routes are slower than usual but still answering.',
    pill: 'pill-yellow',
    icon: AlertTriangle,
    tag: 'Partial degradation',
  },
  major: {
    title: 'Active incident in progress.',
    sub: 'At least one customer-facing route is down. The engineering team is on it.',
    pill: 'pill-red',
    icon: AlertOctagon,
    tag: 'Active incident',
  },
  unknown: {
    title: 'Bringing systems online.',
    sub: 'Status data is still warming up after a recent reload.',
    pill: 'pill',
    icon: Loader2,
    tag: 'Warming up',
  },
};

export default function OverallBanner({ status, updatedAt }: { status: Overall; updatedAt: string }) {
  const c = COPY[status];
  const Icon = c.icon;
  const stamp = new Date(updatedAt).toLocaleString();
  return (
    <section className="pt-28 md:pt-32 pb-6">
      <div className="card relative overflow-hidden">
        <div className={c.pill + ' mb-4'}>
          <Icon className={`w-4 h-4 ${status === 'unknown' ? 'animate-spin' : ''}`} />
          {c.tag}
        </div>
        <h1 className="display text-4xl md:text-5xl leading-tight text-offwhite">
          {c.title}
        </h1>
        <p className="text-offwhite/75 mt-3 max-w-2xl text-base md:text-lg">{c.sub}</p>
        <p className="text-xs text-offwhite/45 mt-5">Updated {stamp}. Auto-refreshes every 30 seconds.</p>
      </div>
    </section>
  );
}
